import { Component, Input } from '@angular/core';
import { GenericValue } from 'hisng';

@Component( {
    selector: 'res-internal-organization-view',
    templateUrl: './internal-organization-view.component.html',
} )
export class InternalOrganizationViewComponent {
    @Input() organizations: GenericValue[]; // ngModel
}
